export default "__VITE_ASSET__dfq6WKHw__"